import React from 'react';
import {Dialog} from "@material-ui/core";
import {css} from "@emotion/react";
import CloseBtn from '../../../public/images/common/btn_close.svg'

const MuiDialog = (props) => {
  const { onClose, open, fullWidth, maxWidth, classes, closeBtnColor, ...custom} = props
  return (
      <div>
        <Dialog
            onClose={onClose}
            open={open}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            classes={classes}>
          <div css={closeBtn} >
            <CloseBtn fill={ closeBtnColor || '#484848' } onClick={onClose}/>
          </div>
          {
            props.children
          }
        </Dialog>
      </div>
  );
};

export default MuiDialog;

const closeBtn = css`
  width: 32px;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
`